export default __webpack_public_path__ + "static/eWise-9733d397eab97a5e95b8517aa464ea9c.gif";